import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyBsH0948hPrCYG6yFavlIRZ1JX55CPPz7E',
  authDomain: 'glasspro.firebaseapp.com',
  projectId: 'glasspro',
  storageBucket: 'glasspro.appspot.com',
  messagingSenderId: '789930432199',
  appId: '1:789930432199:web:b56134c24db523fde0d0e2',
  measurementId: 'G-PZPCD503Z1',
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

export const fs = firebase.firestore()
export const auth = firebase.auth()
